// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./icons/platform/desktop.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./icons/platform/mobile.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./icons/platform/server.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./icons/browser/chrome.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./icons/browser/deno.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./icons/browser/edge.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("./icons/browser/firefox.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("./icons/browser/nodejs.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("./icons/browser/opera.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("./icons/browser/safari.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("./icons/browser/samsunginternet.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("./icons/browser/webview.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("./icons/status/no.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("./icons/status/partial.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("./icons/status/yes.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("./icons/status/yes-circle.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("./icons/status/experimental.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("./icons/status/deprecated.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("./icons/status/nonstandard.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("./icons/status/footnote.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("./icons/status/unknown.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("./icons/status/prefix.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("./icons/status/altname.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("./icons/status/disabled.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("./icons/status/more.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("./icons/status/preview.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.icon {
  --color: var(--icon-primary, light-dark(#696969, #ffffff));
  --size: var(--icon-size, 1rem);

  display: inline-block;

  flex-shrink: 0;

  width: var(--size);
  height: var(--size);

  vertical-align: middle;

  background-color: var(--color);

  mask-repeat: no-repeat;
  mask-position: center center;

  /** Platform icons. */
  &.icon-desktop {
    mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  }

  &.icon-mobile {
    mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  }

  &.icon-server {
    mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  }

  /** Browser icons. */

  &.icon-chrome {
    mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  }

  &.icon-deno {
    mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  }

  &.icon-edge {
    mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  }

  &.icon-firefox {
    mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  }

  &.icon-edge {
    mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  }

  &.icon-nodejs {
    mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  }

  &.icon-opera {
    mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  }

  &.icon-safari {
    mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  }

  &.icon-samsunginternet {
    mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  }

  &.icon-webview {
    mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  }

  /** Status icons. */

  &.icon-no {
    mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  }

  &.icon-partial {
    mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
  }

  &.icon-yes {
    mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
  }

  &.icon-yes-circle {
    mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
  }

  &.icon-experimental {
    mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
  }

  &.icon-deprecated {
    mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
  }

  &.icon-nonstandard {
    mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
  }

  &.icon-footnote {
    mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  }

  &.icon-unknown {
    mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
  }

  &.icon-prefix {
    mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
  }

  &.icon-altname {
    mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
  }

  &.icon-disabled {
    mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_23___});
  }

  &.icon-more {
    mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_24___});
  }

  &.icon-preview {
    mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_25___});
  }
}
`, "",{"version":3,"sources":["webpack://./components/compat/icons.css"],"names":[],"mappings":"AAAA;EACE,0DAA0D;EAC1D,8BAA8B;;EAE9B,qBAAqB;;EAErB,cAAc;;EAEd,kBAAkB;EAClB,mBAAmB;;EAEnB,sBAAsB;;EAEtB,8BAA8B;;EAE9B,sBAAsB;EACtB,4BAA4B;;EAE5B,qBAAqB;EACrB;IACE,mDAA+C;EACjD;;EAEA;IACE,mDAA8C;EAChD;;EAEA;IACE,mDAA8C;EAChD;;EAEA,oBAAoB;;EAEpB;IACE,mDAA6C;EAC/C;;EAEA;IACE,mDAA2C;EAC7C;;EAEA;IACE,mDAA2C;EAC7C;;EAEA;IACE,mDAA8C;EAChD;;EAEA;IACE,mDAA2C;EAC7C;;EAEA;IACE,mDAA6C;EAC/C;;EAEA;IACE,mDAA4C;EAC9C;;EAEA;IACE,mDAA6C;EAC/C;;EAEA;IACE,oDAAsD;EACxD;;EAEA;IACE,oDAA8C;EAChD;;EAEA,mBAAmB;;EAEnB;IACE,oDAAwC;EAC1C;;EAEA;IACE,oDAA6C;EAC/C;;EAEA;IACE,oDAAyC;EAC3C;;EAEA;IACE,oDAAgD;EAClD;;EAEA;IACE,oDAAkD;EACpD;;EAEA;IACE,oDAAgD;EAClD;;EAEA;IACE,oDAAiD;EACnD;;EAEA;IACE,oDAA8C;EAChD;;EAEA;IACE,oDAA6C;EAC/C;;EAEA;IACE,oDAA4C;EAC9C;;EAEA;IACE,oDAA6C;EAC/C;;EAEA;IACE,oDAA8C;EAChD;;EAEA;IACE,oDAA0C;EAC5C;;EAEA;IACE,oDAA6C;EAC/C;AACF","sourcesContent":[".icon {\n  --color: var(--icon-primary, light-dark(#696969, #ffffff));\n  --size: var(--icon-size, 1rem);\n\n  display: inline-block;\n\n  flex-shrink: 0;\n\n  width: var(--size);\n  height: var(--size);\n\n  vertical-align: middle;\n\n  background-color: var(--color);\n\n  mask-repeat: no-repeat;\n  mask-position: center center;\n\n  /** Platform icons. */\n  &.icon-desktop {\n    mask-image: url(\"./icons/platform/desktop.svg\");\n  }\n\n  &.icon-mobile {\n    mask-image: url(\"./icons/platform/mobile.svg\");\n  }\n\n  &.icon-server {\n    mask-image: url(\"./icons/platform/server.svg\");\n  }\n\n  /** Browser icons. */\n\n  &.icon-chrome {\n    mask-image: url(\"./icons/browser/chrome.svg\");\n  }\n\n  &.icon-deno {\n    mask-image: url(\"./icons/browser/deno.svg\");\n  }\n\n  &.icon-edge {\n    mask-image: url(\"./icons/browser/edge.svg\");\n  }\n\n  &.icon-firefox {\n    mask-image: url(\"./icons/browser/firefox.svg\");\n  }\n\n  &.icon-edge {\n    mask-image: url(\"./icons/browser/edge.svg\");\n  }\n\n  &.icon-nodejs {\n    mask-image: url(\"./icons/browser/nodejs.svg\");\n  }\n\n  &.icon-opera {\n    mask-image: url(\"./icons/browser/opera.svg\");\n  }\n\n  &.icon-safari {\n    mask-image: url(\"./icons/browser/safari.svg\");\n  }\n\n  &.icon-samsunginternet {\n    mask-image: url(\"./icons/browser/samsunginternet.svg\");\n  }\n\n  &.icon-webview {\n    mask-image: url(\"./icons/browser/webview.svg\");\n  }\n\n  /** Status icons. */\n\n  &.icon-no {\n    mask-image: url(\"./icons/status/no.svg\");\n  }\n\n  &.icon-partial {\n    mask-image: url(\"./icons/status/partial.svg\");\n  }\n\n  &.icon-yes {\n    mask-image: url(\"./icons/status/yes.svg\");\n  }\n\n  &.icon-yes-circle {\n    mask-image: url(\"./icons/status/yes-circle.svg\");\n  }\n\n  &.icon-experimental {\n    mask-image: url(\"./icons/status/experimental.svg\");\n  }\n\n  &.icon-deprecated {\n    mask-image: url(\"./icons/status/deprecated.svg\");\n  }\n\n  &.icon-nonstandard {\n    mask-image: url(\"./icons/status/nonstandard.svg\");\n  }\n\n  &.icon-footnote {\n    mask-image: url(\"./icons/status/footnote.svg\");\n  }\n\n  &.icon-unknown {\n    mask-image: url(\"./icons/status/unknown.svg\");\n  }\n\n  &.icon-prefix {\n    mask-image: url(\"./icons/status/prefix.svg\");\n  }\n\n  &.icon-altname {\n    mask-image: url(\"./icons/status/altname.svg\");\n  }\n\n  &.icon-disabled {\n    mask-image: url(\"./icons/status/disabled.svg\");\n  }\n\n  &.icon-more {\n    mask-image: url(\"./icons/status/more.svg\");\n  }\n\n  &.icon-preview {\n    mask-image: url(\"./icons/status/preview.svg\");\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___.toString();
